export default "__VITE_ASSET__v6fksCV2__"